import { API_CALL_SUCCESS } from 'actions/actionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import { FETCH_RELATED_TRAVEL_DESTINATIONS } from 'actions/apiActionConstants'

export const initialDestinationProductPageState: App.DestinationProductPageState = {
  relatedTravelDestinations: {},
}

const apiCalls = apiReducerSwitch<App.DestinationProductPageState>({
  [FETCH_RELATED_TRAVEL_DESTINATIONS]: {
    success: (state, action) => ({
      relatedTravelDestinations: {
        ...state.relatedTravelDestinations,
        [action.location]: action.data,
      },
    }),
  },
})

const destinationProductPageReducer = createAppReducer<App.DestinationProductPageState>(initialDestinationProductPageState, {
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
})

export default destinationProductPageReducer
